import React, { ReactNode, useEffect, useRef, useState } from "react";
import ButtonIcon from "./ButtonIcon";
import Image from 'next/image'
import gsap from "gsap";


const TeamPOPUP = ({openPopUp = false, setOpenPopup, popUpData, popUpIndex, infoTitles}) => {

  const title = useRef()
  const role = useRef()
  const email = useRef()
  const info = useRef()
  const containerScroll = useRef()

  const [isLoaded, setIsLoaded] = useState(false);

  const currentImageSrc = popUpData[popUpIndex]?.acf?.image?.url;

  // Сбрасываем флаг загрузки при смене изображения
  useEffect(() => {
    setIsLoaded(false);
  }, [currentImageSrc]);


  useEffect(()=> {
    if (openPopUp) {
      gsap.fromTo(title.current, {opacity: 0}, {opacity:1, duration: 0.6, delay: 0.4})
      if (role.current) {
        gsap.fromTo(role.current, {opacity: 0}, {opacity:1, duration: 0.6, delay: 0.5})
      }
      if (email.current) {
        gsap.fromTo(email.current, {opacity: 0}, {opacity:1, duration: 0.6, delay: 0.6})
      }
      if (info.current) {
        gsap.fromTo(info.current, {opacity: 0}, {opacity:1, duration: 0.6,delay: 0.7})
      }
      
    }
  }, [openPopUp])

  useEffect(() => {

  if ((openPopUp && window.innerWidth < 768) || (openPopUp && containerScroll.current.offsetHeight - 2 > window.innerHeight)) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
  return () => {
    document.body.style.overflow = "";
  };
  }, [openPopUp]);

  return (
    <>
    <div   className={`${openPopUp ? 'opacity-40 ' : 'opacity-0 '} pointer-events-none transition-opacity ease-out duration-700 bg-dark-blue fixed  z-[69]  inset-0`}></div>

    <div  className={` pointer-events-none left-0 fixed ease-out  flex justify-end h-screen w-full top-0 z-[70]`}
    >
      <div  onClick={()=> {setOpenPopup(false)}} className={`${openPopUp ? 'pointer-events-auto' : 'pointer-events-none'} absolute cursor-pointer inset-0`}></div>
 
      {/* <div className="bg-dark-blue absolute opacity-60 inset-0"></div> */}
      <div className={`${openPopUp ? 'left-0' : 'lg:left-[50%] left-[100%]'} duration-700 transition-[left] ease-out lg:w-1/2 overflow-y-auto pointer-events-auto relative pb-[4rem] container-padding w-full justify-start pt-[10rem] lg:pt-[5rem] z-10 flex flex-col items-start h-full bg-beige`}>
          <ButtonIcon ariaLabel="Закрыть окно" onClick={()=> {setOpenPopup(false)}} className=" absolute cursor-pointer right-[2.6rem] md:right-[3rem] md:top-[2.8rem] top-[2.1rem] ">
          <svg  className="h-[1.8rem]" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 7L1 1M7 7L1 13M7 7L13 1M7 7L13 13" stroke="CurrentColor"/>
          </svg>
      </ButtonIcon>

        <div ref={containerScroll} className="flex  flex-col w-full">
          <div className="flex md:flex-row-reverse flex-col w-full md:gap-[1.6rem] lg:gap-[3.2rem]">
          <div className="md:w-[50%] mb-[3.2rem] md:pt-[7rem]">
          <p ref={title} className="heading-3 mb-[1.2rem]">{popUpData[popUpIndex].title}</p>
          <p ref={role} className="mb-[2rem] text-1">{popUpData[popUpIndex].acf.position}</p>

          {popUpData[popUpIndex].acf.email ? <a ref={email} href={`mailto:${popUpData[popUpIndex].acf.email}`} className="font-inter text-[1.6rem]  text-dusty-green-dark">{popUpData[popUpIndex].acf.email}</a> : null }
                    </div>
          <div className="md:w-[50%] mb-[1.2rem] aspect-[0.89/1] relative w-full">
            <Image
              src={popUpData[popUpIndex].acf?.image?.url}
              alt={popUpData[popUpIndex].acf?.image?.alt}
              fill
              sizes="700px"
              onLoad={() => setIsLoaded(true)}
              className={`w-auto object-cover ${isLoaded ? "opacity-100" : "opacity-0"}`}
            />
            </div>
          </div>

          <div ref={info} className="md:pt-[5rem] gap-x-[3.2rem] gap-y-[2.4rem] md:gap-y-[4rem] w-full grid md:grid-cols-2">
            {popUpData[popUpIndex].acf.inspired ? <div className="xl:pr-[2rem]"><p className="heading-4 mb-[1.6rem]">{infoTitles.inspired_title}</p><p className="text-1">{popUpData[popUpIndex].acf.inspired}</p></div> : null}
            {popUpData[popUpIndex].acf.design ? <div className="xl:pr-[2rem]"><p className="heading-4 mb-[1.6rem]">{infoTitles.design_title}</p><p className="text-1">{popUpData[popUpIndex].acf.design}</p></div> : null}
            {popUpData[popUpIndex].acf.creative ? <div className="xl:pr-[2rem]"><p className="heading-4 mb-[1.6rem]">{infoTitles.creative_title}</p><p className="text-1">{popUpData[popUpIndex].acf.creative}</p></div> : null}

            {/* <h4 className="mb-[2rem]">{popUpData[popUpIndex].acf.blockquote}</h4>
            <div className="flex flex-col gap-[1.2rem] md:gap-[1.6rem] md:flex-row">
              <p className="text-1 md:w-1/2">{popUpData[popUpIndex].acf.bio}</p>
              <p className="text-1 md:w-1/2">{popUpData[popUpIndex].acf.description}</p>
            </div> */}
            
          </div>
                 
        </div>
      </div>
      
    </div>
        </>
  );
};

export default TeamPOPUP;